module.exports = [
  {
    text: "HRMS Onboarding",
    // logo: `${process.env.PUBLIC_URL}/assets/images/logos/hrms1.svg`,
    linkUrl: "https://hrmsonboarding.leadspireconsulting.com/",
  },
  {
    text: "Hubble Orion AMS",
    // logo: `${process.env.PUBLIC_URL}/assets/images/logos/hrms1.svg`, 
    linkUrl: "https://ams.leadspireconsulting.com/",
  },
  {
    logo: `${process.env.PUBLIC_URL}/assets/images/logos/people_strong.svg`,
    linkUrl: "https://auth.peoplestrong.com/",
  },
];